import React, { useState, useEffect, useCallback } from "react";
import moment from 'moment';


import { Grid, Typography, MenuItem, Select, Autocomplete, TextField, InputLabel } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';

import {
  DataGrid,
  GridEditCellProps
} from '@mui/x-data-grid';
import CMAutocomplete from '../../components/molecules/CMAutocomplete';

import { Icon } from '@mui/material';
import { PictureAsPdf } from '@mui/icons-material';
import * as XLSX from 'xlsx';
import { useParams, useHistory } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

//Components
import CMLabel from '../../components/atoms/CMLabel';
import CMDatePicker from '../../components/molecules/CMDatePicker';
import CMButton from '../../components/atoms/CMButton';
import CMIconButton from '../../components/atoms/CMIconButton';
import DeleteIcon from '@mui/icons-material/Delete';

//Constants
import { MomentLocaleEs } from '../../constants/MomentLocaleEs';
//Services
import * as OrdenesService from '../../services/OrdenesService';
import * as ProveedorService from '../../services/ProveedorService';
import * as ProyectoService from '../../services/ProyectoService';


import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import CMTextField from "../../components/atoms/CMTextField";
import { v4 as uuidv4 } from 'uuid';
import Checkbox from '@mui/material/Checkbox';

import './CrearOrdenes.css'
const MySwal = withReactContent(Swal)


const CrearOrdenesServicio = () => {
  const [rowsdata, setRowsdata] = useState([]);
  const [rowsgrid, setRowsgrid] = useState([]);
  const [comment, setComment] = useState('');
  //Nuevo
  const [proveedor, setProveedor] = useState([]);
  const [ruc, setRuc] = useState('');
  const [idprovedor, setIdprovedor] = useState([]);
  const [nombreProveedor, setNombreProvedor] = useState([]);
  const [codigoProveedorsap, setCodigoProveedorsap] = useState([]);
  const [contacto, setContacto] = useState([]);
  const [selectPersonaContacto, setSelectPersonaContacto] = useState(null);
  const [fechacontable, setFechacontable] = useState(moment().locale('es', MomentLocaleEs));
  const [fechaentrega, setFechaentrega] = useState(moment().locale('es', MomentLocaleEs));
  const [fecharegistro, setFecharegistro] = useState([]);
  const [motivotraslado, setMotivotraslado] = useState('');
  const [selectProveedor, setSelectProveedor] = useState(null);
  const [tipocambio, setTipocambio] = useState('S/');
  const [idcontacto,setIdcontacto] = useState([]);
  const [condiciondepago, setCondicionDepago] = useState([]);
  const [destino, setDestino] = useState('');
  const [observaciones, setObservaciones] = useState('');
  const [selectedConditionPago, setSelectedConditionPago] = useState(null); // Estado para almacenar la condición seleccionada
  const [selectedDestino, setSelectedDestino] = useState(null); // Estado para almacenar la condición seleccionada
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cecos, setCecos] = useState([]);
  const [almacenes, setAlmacenes] = useState([]);
  const [cuentaContable, setCuentaContable] = useState([]);
  const [editedCecos, setEditedCecos] = useState([]);
  const [editedAlmacenes,setEditedAlmacenes] = useState([]);
  const [editedCuentaContable, setEditedCuentaContable] = useState([]); // Inicializar con un arreglo vacío
	const [cargando, setCargando] = React.useState(false);
  const [serieDocumento, setSerieDocumento] = useState('');
  const [correlativoDocumento, setCorrelativoDocumento] = useState('');

  const [tipoDocumento, setTipoDocumento] = useState('00')

  const [optionDestino, setOptionDestino] =useState([]);

  const [records, setRecords] = useState([]);
  const [products, setProducts] = useState(null);
  const [valueProduct, setValueProduct] = useState('');
  const [selectionProduct, setSelectionProduct] = useState(null);
  const [open, setOpen] = useState(false);
	const [options, setOptions] = useState([]);
	const [loadingGrid, setLoadingGrid] =  useState(false);
  const loading = open && options.length === 0;
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const [nextId, setNextId] = useState(1); // Variable para generar claves únicas
  const user = JSON.parse(window.localStorage.getItem("user"));
  const [registrarbtn, setRegistrarbtn] = useState(true);
  const [correo, setCorreo] = useState('');
  const [fechahoy,setFechahoy] =useState(moment().locale('es', MomentLocaleEs));
  const [proyectos, setProyectos] = useState([]);
  const [etapas, setEtapas] = useState([]);

  const [editedProyectos, setEditedProyectos] = useState([]);

  useEffect(() => {
  OrdenesService.getListProveedores(setProveedor, user.token);
  OrdenesService.getListPersonaContacto(setContacto, user.token);
  OrdenesService.getListDestino(setDestino, user.token);
  OrdenesService.getListProducts(setProducts, user.token);
  OrdenesService.getListCecos(setCecos, user.token);
  OrdenesService.getListAlmacen(setAlmacenes, user.token);
  OrdenesService.getListCuentaContable(setCuentaContable, user.token);

  // Con manejo de error para API opcional:
  try {
    ProyectoService.getProjects(
      (data) => setProyectos(Array.isArray(data) ? data : []),
      user.token
    );
  } catch (e) {
    setProyectos([]);
  }
}, []);

  useEffect(() => {
    let active = true;

    if (!loading)
      return undefined;

    (async () => {
      if (active)
        setOptions([...products]);
    })();

    return () => { active = false; };
  }, [loading]);

  useEffect(() => {
    if (!open)
      setOptions([]);
  }, [open])


  const message = (text, type) => {
    setNotify({
      isOpen: true,
      message: text,
      type: type
    })
  }

  // const handleAddProduct = () => {
  //   if (selectedProduct && !isProductAlreadyAdded(selectedProduct)) {
  //     const newProduct = {
  //       ...selectedProduct,
  //       id: nextId, // Asignar una clave única al producto
  //       precio_unitario: 0, // Valor inicial para el campo editable "Precio Unitario"
  //       cantidad_pedida: 0, // Valor inicial para el campo editable "Cantidad pedida"
  //       total_articulo:0, // Valor inicial para el campo editable "Total
  //       fecha_entrega: null, // Valor inicial para el campo editable "Fecha Entrega"
  //       codigo_ceco: null,
  //       codigo_departamento: null,
  //       codigo_seccion:null,
  //       codigo_almacen_sap:null
  //     };
  //     setSelectedProducts([...selectedProducts, newProduct]);
  //     setSelectedProduct(null);
  //     setNextId(nextId + 1); // Incrementar el valor de la próxima clave única
  //   }
  // };
 
  const isProductAlreadyAdded = (product) => {
    return selectedProducts.some((p) => p.codigo_producto_sap === product.codigo_producto_sap);
  };

  //Fin nuevo

  const useFakeMutation = () => {
    return React.useCallback(
      (user) =>
        new Promise((resolve, reject) =>
          setTimeout(() => {
            if (user.name?.trim() === '') {
              reject(new Error("Error al guardar el usuario: el nombre no puede estar vacÃ­o"));
            } else {
              resolve({ ...user, name: user.name?.toUpperCase() });
            }
          }, 200),
        ),
      [],
    );
  };
  const mutateRow = useFakeMutation();
  const [snackbar, setSnackbar] = useState(null);
  const [dataresponse, setDataresponse] = useState(null);
  const handleCloseSnackbar = () => setSnackbar(null);
  const handleProcessRowUpdateError = React.useCallback((error) => {
    setSnackbar({ children: error.message, severity: 'error' });
  }, []);

  const { ordenid } = useParams();

  let idCounter = 0; // Inicializamos el contador

  // useEffect(() => {
  //   if (rowsdata.oc_detalles) {
  //     const rowsWithId = rowsdata.oc_detalles.map(row => ({
  //       ...row,
  //       id: idCounter++
  //     }));
  //     setRowsgrid(rowsWithId);
  //   }
  // }, [rowsdata]);


  const formatCurrency = (value) => {
    return value.toLocaleString('es-PE', {
      style: 'currency',
      currency: 'PEN',
    });
  };



  const formatNumberWithDot = (number) => {
    return number.toString().replace(',', '.');
  };

  const parseNumberWithDot = (value) => {
    return value.replace('.', ',');
  };

  
  const handleCellValueChange = async (params, newValue,codigo_ceco) => {
    const { id } = params;
    const editedCecoIndex = editedCecos.findIndex((ceco) => ceco.id === id);
  
    if (editedCecoIndex !== -1) {
      // Si el ceco ya ha sido editado previamente, actualiza su valor
      const updatedCecos = [...editedCecos];
      updatedCecos[editedCecoIndex] = { id, nombre_ceco: newValue, codigo_ceco};
      setEditedCecos(updatedCecos);
    } else {
      // Si es un ceco nuevo, añádelo al estado de editedCecos
      setEditedCecos((prevCecos) => [...prevCecos, { id, nombre_ceco: newValue, codigo_ceco }]);
    }
  
    try {
      // Obtener los valores de codigo_departamente, codigo_seccion y codigo_ceco del API getCecosId
      const response = await OrdenesService.getCecosId(codigo_ceco, user.token);
      if (response) {
        const { codigo_departamente, codigo_seccion } = response;
  
        // Actualizar los campos relacionados en la fila actual
        const updatedRecords = records.map((record) => {
          if (record.id === id) {
            return { ...record, nombre_ceco: newValue, codigo_departamente, codigo_seccion, codigo_ceco };
          }
          return record;
        });
        setRecords(updatedRecords);
      } else {
        console.error('La respuesta del API getCecosId no es válida:', response);
      }
    } catch (error) {
      // Manejar el error aquí
      console.error('Error al obtener los valores de codigo_departamente y codigo_seccion:', error);
    }
  };
  const handleCellValueChangeCuentaContable = (params, newValue,nombre_cuenta_contable, codigo_cuenta_contable) => {
    const { id } = params;
    const editedCuentaIndex = editedCuentaContable.findIndex((cuenta) => cuenta.id === id);
  
    if (editedCuentaIndex !== -1) {
      // Si la cuenta contable ya ha sido editada previamente, actualiza su valor
      const updatedCuentas = [...editedCuentaContable];
      updatedCuentas[editedCuentaIndex] = { id, nombre_cuenta: newValue,nombre_cuenta_contable, codigo_cuenta_contable };
      setEditedCuentaContable(updatedCuentas);
    } else {
      // Si es una cuenta contable nueva, añádela al estado de editedCuentaContable
      setEditedCuentaContable((prevCuentas) => [...prevCuentas, { id, nombre_cuenta: newValue, nombre_cuenta_contable,codigo_cuenta_contable }]);
    }
  
    // Actualizar los campos relacionados en la fila actual
    const updatedRecords = records.map((record) => {
      if (record.id === id) {
        return { ...record, nombre_cuenta: newValue,nombre_cuenta_contable, codigo_cuenta_contable };
      }
      return record;
    });
    setRecords(updatedRecords);
  };

  const handleCellValueChangeProyecto = async (params, newValue) => {
    const name = newValue ? newValue.split(' -- ')[0] : '';
    const docnum = newValue ? newValue.split(' -- ')[1] : '';
  
    // Actualizar estado de proyectos editados
    setEditedProyectos((prev) => {
      const updatedList = prev.some((p) => p.absEntry === params.id)
        ? prev.map((p) => (p.absEntry === params.id ? { ...p, name, docnum } : p))
        : [...prev, { absEntry: params.id, name, docnum }];
      
      return updatedList;
    });
  
    try {
      // Buscar el proyecto seleccionado
      const selectedProyecto = Array.isArray(proyectos) 
    ? proyectos.find((p) => p.name === name) 
    : null;
      if (selectedProyecto) {
        // console.log(selectedProyecto);
        const { fiProject, absEntry } = selectedProyecto;
  
        // Actualizar el estado de records
        setRecords((prevRecords) =>
          prevRecords.map((record) =>
            record.id === params.id
              ? {
                  ...record,
                  fiProject,
                  AbsEntryProyecto: absEntry, // Guardamos AbsEntryProyecto correctamente
                  DocNumProyecto:selectedProyecto.docnum,
                  NombreProyecto: name,
                  stageId: null, // Resetear la etapa
                  etapa: '',
                }
              : record
          )
        );
  
        // Obtener las etapas del nuevo proyecto
        ProyectoService.getStagesByProject(absEntry, user.token, setEtapas);
      } else {
        console.error('Proyecto no encontrado:', name);
      }
    } catch (error) {
      console.error('Error al obtener el fiProject:', error);
    }
  };
  
  const handleProductChange = (value) => {
    if(options.includes(value)){
      setSelectionProduct(value);
    }
    else{
			setSelectionProduct(null);
		}
  };
  const handleSelectChange = (params, selectedValue) => {
    let newValue;
    if (selectedValue === 'IGV_HR') {
      newValue = 0.105; // Sin IGV
    } else if (selectedValue === 'IGV') {
      newValue = 0.18; // IGV 18%
    } else if (selectedValue === 'EXE_IGV') {
      newValue = 0; // Sin IGV
    }
  else if (selectedValue === '') {
    newValue = ""; // Sin IGV
  }
    else {
      // Manejar cualquier otro caso o error
      newValue = null;
    }
    // Llama a la función que maneja el cambio del valor de la celda
    // Pasa el nuevo valor y los parámetros necesarios
    handleCheckboxChange(params, newValue);
  };
  const agregarServicio = () => {
    // Crear el nuevo objeto de la fila a agregar
    const nuevaFila = {
      id: uuidv4(),
      descripcion:'',
      Valor_unitario: '',
      igv:'',
      precio_unitario: '',
      fecha_entrega: '',
      nombre_ceco: '',
      codigo_departamente:'',
      codigo_seccion:'',
      nombre_cuenta:'',
      nombre_cuenta_contable:'',
      codigo_cuenta_contable:'',
      incluyeIgv:'',
      proyecto:'',
      etapas:'',
      fiProject:'',
      AbsEntryProyecto:'',
      NombreProyecto:'',
      DocNumProyecto:'',
      FiProject:'',
      StageIdEtapa:'',
      NombreEtapa:''
    };
  
    // Agregar la nueva fila al array de records
    const nuevosRecords = [...records, nuevaFila];
  
    // Actualizar el estado de records con la nueva fila agregada
    setRecords(nuevosRecords);
  };
  const [includeIgv, setIncludeIgv] = useState(false);

  const handleCheckboxChange = (params, checked) => {
    // Actualizar el valor de incluyeIgv en los datos de esa fila
    const updatedRow = {...params.row, incluyeIgv: checked};
    
    setRecords(rows => 
      rows.map(row => 
        row.id === params.id ? updatedRow : row  
      )
    );
  }

  const handleStageChange = (params, newValue) => {
    const selectedStage = Array.isArray(etapas) 
    ? etapas.find((stage) => stage.name === newValue) 
    : null;
    const stageId = selectedStage ? selectedStage.stageId : null;
  
    setRecords((prevRecords) =>
      prevRecords.map((record) =>
        record.id === params.id ? { ...record, stageId,StageIdEtapa:stageId, etapa: newValue,NombreEtapa:newValue } : record
      )
    );
  };
  const columns = [
    {
      field: "accion", headerName: "Acción", width: 80, sortable: false, filterable: false, justifyContent: "center",
      renderCell: (cellValues) => {
        return (
          <CMIconButton onClick={() => {setRecords(records.filter(record => record.id !== cellValues.id))}}>
            <DeleteIcon/>
          </CMIconButton>
        )
      }
    },
    {
      field: 'incluyeIgv',
      headerName: 'Incluye IGV?',
      width: 150,
      renderCell: (params) => {
        console.log(params.value);
        return (
          <Select
          value={
            params.value === null || params.value === undefined || params.value === ""
            ? "":
           params.value === 0.105
              ? 'IGV_HR'
              : params.value === 0
              ? 'EXE_IGV'
              : params.value === 0.18
              ? 'IGV'
              : ''
          }
          fullWidth
          onChange={(e) => handleSelectChange(params, e.target.value)}
        >
          <MenuItem value="EXE_IGV">SIN IGV</MenuItem>
          <MenuItem value="IGV">IGV 18%</MenuItem>
          <MenuItem value="IGV_HR">IGV 10.5%</MenuItem>
        </Select>
        );
      }
    },
    {
      field: 'descripcion',
      headerName: 'Descripcion',
      width: 360,
      type: 'string',
      editable: true,
      cellClassName: 'gray-column', 
    },
    {
      field: 'Valor_unitario',
      headerName: 'Valor unitario',
      width: 120,
      type: 'number',
      editable: true,
      cellClassName: 'gray-column', // Clase CSS personalizada para aplicar el color gris
      valueFormatter: (params) => params.value ? formatNumberWithDot(params.value) : '',
    },
    {
      field: 'igv',
      headerName: 'IGV',
      width: 120,  
      valueGetter: (params) => {
        const valorUnitario = params.row.Valor_unitario;
        const incluyeIgv = params.row.incluyeIgv;     
        // Calcula el monto del IGV
        const igvAmount = incluyeIgv * valorUnitario;
        return valorUnitario ? igvAmount.toFixed(2) : '';
      }
    },
    {
      field: 'precio_unitario',
      headerName: 'Precio',
      width: 120,
      type: 'number',
      valueGetter: (params) => {
        const valorUnitario = params.row.Valor_unitario;
        const incluyeIgv = params.row.incluyeIgv; 
        // const igv = incluyeIgv==='0.18' ? 1.18 :incluyeIgv==='0.1'? '1.10': 1;
        return valorUnitario ? ((valorUnitario * incluyeIgv)+valorUnitario).toFixed(2) : '';
      }
    },
    {
      field: 'fecha_entrega',
      headerName: 'Fecha Entrega',
      width: 120,
      type: 'date',
      cellClassName: 'gray-column', // Clase CSS personalizada para aplicar el color gris
      editable: true,
      valueFormatter: (params) => params.value ? moment(params.value).format('DD/MM/YYYY') :'00/00/0000'
    },
    {
      field: 'nombre_ceco',
      headerName: 'Nombre Ceco',
      width: 240,
      editable: true,
      cellClassName: 'gray-column', // Clase CSS personalizada para aplicar el color gris
      renderCell: (params) => {
        const ceco = cecos.find((ceco) => ceco.id === params.value);
        const selectedValue = editedCecos.find((ceco) => ceco.id === params.id)?.nombre_ceco;
        const value = selectedValue || (ceco ? ceco.nombre_ceco : '');
        return value;
      },
      renderEditCell: (params) => {
        const editedCeco = editedCecos.find((ceco) => ceco.id === params.id);
        const value = editedCeco ? editedCeco.nombre_ceco : params.value;
        const ceco = cecos.find((ceco) => ceco.id === params.value); // Obtener el ceco correspondiente
        const codigo_ceco = ceco ? ceco.codigo_ceco : ''; // Obtener el codigo_ceco del ceco correspondiente
      
        return (
          <Autocomplete
            options={cecos.map((ceco) => `${ceco.nombre_ceco} | ${ceco.codigo_ceco}`)}
            value={value || ''}
            fullWidth
            onChange={(event, newValue) => {
              const selectedCodigoCeco = newValue ? newValue.split(' | ')[1] : ''; // Obtener el codigo_ceco del valor seleccionado
              handleCellValueChange(params, newValue, selectedCodigoCeco); // Pasar selectedCodigoCeco como tercer parámetro
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                autoFocus
                onKeyPress={(event) => {
                  if (event.key === 'Enter') {
                    // Realizar la acción de búsqueda al presionar Enter
                    handleCellValueChange(params, event.target.value, codigo_ceco);
                  }
                }}
              />
            )}
            onClick={(event) => {
              // Realizar la acción de búsqueda al hacer clic
              handleCellValueChange(params, event.target.textContent, codigo_ceco);
            }}
          />
        );
      },
    },
    {
      field: 'codigo_departamente',
      headerName: 'Codigo Departamento',
      width: 160,
      valueFormatter: (params) => params.value
    },
    {
      field: 'codigo_seccion',
      headerName: 'Codigo sección',
      width: 160,
      valueFormatter: (params) => params.value
    },
    {
      field: 'nombre_cuenta',
      headerName: 'Cuenta contable',
      width: 200,
      editable: true,
      cellClassName: 'gray-column', // Clase CSS personalizada para aplicar el color gris
      renderCell: (params) => {
        const cuentaconta = cuentaContable.find((cuenta) => cuenta.id === params.value);
        const editedCuenta = editedCuentaContable.find((cuenta) => cuenta.id === params.id);
        const selectedValue = editedCuenta?.nombre_cuenta_contable;
        const value = selectedValue || (cuentaconta ? `${cuentaconta.nombre_cuenta_contable} -- ${cuentaconta.codigo_cuenta_contable}` : '');
        return value;
      },
      renderEditCell: (params) => {
        const editedCuentaContable = cuentaContable.find((cuenta) => cuenta.id === params.id);
  const value = editedCuentaContable ? editedCuentaContable.nombre_cuenta_contable : params.value;
  const cuenta = cuentaContable.find((cuenta) => cuenta.id === params.value); // Obtener la cuenta contable correspondiente
    
        return (
          <Autocomplete
            options={cuentaContable.map((cuenta) => `${cuenta.nombre_cuenta_contable} -- ${cuenta.codigo_cuenta_contable}`)}
            value={value || ''}
            fullWidth
            onChange={(event, newValue) => {
              const nombre_cuenta_contable = newValue ? newValue.split(' -- ')[0] : ''; // Obtener el código de cuenta contable del valor seleccionado
              const codigo_cuenta_contable = newValue ? newValue.split(' -- ')[1] : ''; // Obtener el código de cuenta contable del valor seleccionado
              handleCellValueChangeCuentaContable(params, newValue, nombre_cuenta_contable,codigo_cuenta_contable);
            }}
            renderInput={(params) => <TextField {...params} autoFocus />}
          />
        );
      },
    },
    {
      field: 'proyecto',
      headerName: 'Proyecto',
      width: 250,
      editable: true,
      cellClassName: 'gray-column',
    
      // Render the project name and fiProject in the cell
      renderCell: (params) => {
        const proyecto = proyectos.find((p) => p.absEntry === params.value);
        const editedProyecto = editedProyectos.find((p) => p.absEntry === params.id);
        const selectedValue = editedProyecto?.name;
        const value = selectedValue 
          ? `${selectedValue} -- ${editedProyecto?.fiProject || ''}` 
          : (proyecto ? `${proyecto.name} -- ${proyecto.fiProject}` : '');
        return value;
      },
    
      // Render Autocomplete when editing the cell
      renderEditCell: (params) => {
        const editedProyecto = proyectos.find((p) => p.absEntry === params.id);
        const value = editedProyecto ? `${editedProyecto.name} -- ${editedProyecto.fiProject}` : params.value;
        
        return (
          <Autocomplete
            options={Array.isArray(proyectos) ? proyectos.map((p) => `${p.name} -- ${p.fiProject}`) : []}
            value={value || ''}
            fullWidth
            onChange={(event, newValue) => {
              const name = newValue ? newValue.split(' -- ')[0] : '';
              const docnum = newValue ? newValue.split(' -- ')[1] : '';
    
              // Find the selected project to get the fiProject
              const selectedProyecto = proyectos.find((p) => p.name === name);
    
              if (selectedProyecto) {
                // Call the function to handle updating the selected project and fiProject separately
                // console.log(selectedProyecto);
                ProyectoService.getStagesByProject(selectedProyecto.absEntry,user.token,setEtapas);
                handleCellValueChangeProyecto(params, newValue);
              }
            }}
            renderInput={(params) => <TextField {...params} autoFocus />}
          />
        );
      },
    },
    
    {
      field: 'fiProject',
      headerName: 'FiProject',
      width: 160,
      valueFormatter: (params) => params.value,
    },
    {
      field: 'etapas',
      headerName: 'Etapas',
      width: 200,
      editable: true,
      cellClassName: 'gray-column',
    
      // Mostrar la etapa seleccionada en la celda
      renderCell: (params) => {
        const record = records.find((rec) => rec.id === params.id);
        return record?.etapa || ''; // Mostrar el nombre de la etapa
      },
    
      // Mostrar Select al editar la celda
      renderEditCell: (params) => {
        return (
          <Autocomplete
            options={Array.isArray(etapas) ? etapas.map((stage) => stage.name) : []} // Opciones con los nombres de las etapas
            value={params.value || ''}
            fullWidth
            onChange={(event, newValue) => handleStageChange(params, newValue)}
            renderInput={(params) => <TextField {...params} autoFocus />}
          />
        );
      },
    }

  ];

  const processRowUpdate = useCallback(
    async (newRow) => {
      if (!newRow || typeof newRow !== 'object') {
        setSnackbar({ children: 'Error: newRow no es válido', severity: 'error' });
        return;
      }
  
      const {
        id,
        descripcion,
        Valor_unitario,
        igv,
        precio_unitario,
        fecha_entrega,
        nombre_ceco,
        codigo_departamente,
        codigo_seccion,
        nombre_cuenta,
        codigo_cuenta_contable,nombre_cuenta_contable,
        incluyeIgv,FiProject,StageIdEtapa,NombreEtapa
      } = newRow;
  
  
      const updatedRecords = records.map((record) => {
        if (record.id === id) {
          return {
            ...record,
            descripcion,
            Valor_unitario,
            igv,
            precio_unitario,
            fecha_entrega,
            nombre_ceco,
            codigo_departamente,
            codigo_seccion,
            nombre_cuenta,
            codigo_cuenta_contable,nombre_cuenta_contable,incluyeIgv,
            FiProject,StageIdEtapa,NombreEtapa
          };
        }
        return record;
      });
  
      setRecords(updatedRecords);
  
      setSnackbar({ children: 'Guardado exitosamente', severity: 'success' });
  
      const updatedRow = { ...newRow };
      const response = await mutateRow(updatedRow);
      setDataresponse(response);
      setRegistrarbtn(false);
      return response;
    },
    [records, mutateRow]
  );

  useEffect(() => {
    if (dataresponse) {
      const {id,descripcion,Valor_unitario,igv,precio_unitario,fecha_entrega,nombre_ceco,codigo_departamente,codigo_seccion,nombre_cuenta,codigo_cuenta_contable,nombre_cuenta_contable,incluyeIgv,FiProject,StageIdEtapa,NombreEtapa} = dataresponse;

       const oldDevices = [...records];
       const rowDeviceIndex = oldDevices.findIndex((dev) => dev.id === id);
       oldDevices[rowDeviceIndex] = {
        ...oldDevices[rowDeviceIndex],
        id,descripcion,Valor_unitario,igv,precio_unitario,fecha_entrega,nombre_ceco,codigo_departamente,codigo_seccion,nombre_cuenta,codigo_cuenta_contable,nombre_cuenta_contable,incluyeIgv,FiProject,StageIdEtapa,NombreEtapa
  };
     setRecords(oldDevices);
    }
  }, [dataresponse])

  const calculaTotales = () => {
    let total_pago_vencido = 0;
  
    const totales = records.map((item) => {
      const total_antes_descuento = item.Valor_unitario * (1 + (item.incluyeIgv || 0));
      total_pago_vencido += total_antes_descuento; // Acumular la suma
  
      return total_pago_vencido;
    });
  
    return {
      totales,
      total_pago_vencido
    };
  };
  const hanbleRegistrar = () => {
    const fechaentregaDate = new Date(fechaentrega);
const fechacontableCabeceraDate = new Date(fechacontable);
const fechaHoy = moment().endOf('day'); // hoy a las 23:59:59
const fechaMinima = moment().subtract(2, 'days').startOf('day'); // hace 2 días a las 00:00:00



  // Validar que la fecha de entrega esté entre el rango permitido
  if (!moment(fechaentrega).isBetween(fechaMinima, fechaHoy, undefined, '[]')) {
    setSnackbar({ children: 'La fecha de entrega debe estar entre hace 2 días y hoy', severity: 'error' });
    return;
  }
  if (!moment(fechacontable).isBetween(fechaMinima, fechaHoy, undefined, '[]')) {
    setSnackbar({ children: 'La fecha de contable debe estar entre hace 2 días y hoy', severity: 'error' });
    return;
  }


    if (fechaentregaDate === fechacontableCabeceraDate || fechaentregaDate+1 > fechacontableCabeceraDate) {
      setSnackbar({ children: 'La fecha de entrega debe ser mayor o igual que la fecha contable Cabecera', severity: 'error' });
      return;
    }
    if(!selectProveedor){
      setSnackbar({ children: 'Falta seleccionar el proveedor', severity: 'error' });
      return;
    }
    if(!selectPersonaContacto){
      setSnackbar({ children: 'Debe seleccionar un proveedor de contacto', severity: 'error' });
      return;
    }
    if(!motivotraslado){
      setSnackbar({ children: 'Debe indicar el motivo del traslado', severity: 'error' });
      return;
    }
    if(!observaciones){
      setSnackbar({ children: 'Debe indicar el resumen de la orden', severity: 'error' });
      return;
    }
    if(!selectedDestino){
      setSnackbar({ children: 'Debe seleccionar el destino', severity: 'error' });
      return;
    }
    // if(!serieDocumento){
    //   setSnackbar({ children: 'Debe indicar la serie de documento', severity: 'error' });
    //   return;
    // }
    // if(!correlativoDocumento){
    //   setSnackbar({ children: 'Debe indicar el correlativo de documento', severity: 'error' });
    //   return;
    // }
    // if(serieDocumento.length < 4){
    //   setSnackbar({ children: 'La seria de documento debe tener 4 caracteres', severity: 'error' });
    //   return;
    // }
    // if (correlativoDocumento.length < 8) {
    //   setSnackbar({ children: 'El correlativo de documento debe tener 8 caracteres', severity: 'error' });
    //   return;
    // }
    if(records.length === 0){
      setSnackbar({ children: 'No hay servicio registrados', severity: 'error' });
      return;
    }
    for (const record of records) {
      // Verificar cada campo del objeto
      if (
        !record.descripcion ||
        !record.Valor_unitario ||
        !record.fecha_entrega ||
        !record.codigo_ceco ||
        !record.codigo_departamente ||
        !record.codigo_seccion ||
        !record.nombre_cuenta_contable ||
        !record.codigo_cuenta_contable  ||
        record.incluyeIgv===null || record.incluyeIgv==='' || record.incluyeIgv===undefined
      ) {
        // Al menos uno de los campos está vacío
        setSnackbar({ children: 'Todos los campos son obligatorios en los Servicios', severity: 'error' });
        return;
      }
      if(record.fecha_entrega === fechacontable || record.fecha_entrega+1 > fechacontable){
        setSnackbar({ children: 'La fecha de entrega en los servicios debe ser mayor o igual a la fecha contable en el detalle de servicios', severity: 'error' });
        return;
      }
      if(record.NombreProyecto !==''){
        if(!record.StageIdEtapa && !record.NombreEtapa){
          setSnackbar({ children: 'Debe llenar tambien los campos de Etapa', severity: 'error' });
        return;
        }
      }
    }
    console.log(records);
    


    Swal.fire({
      title: 'REGISTRO DE SOLICITUD ORDEN DE SERVICIO',
      text: "¿ESTA CONFORME CON LO REGISTRADO?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        setCargando(true);
         const datosOrden = {
          id_oc_cabecera: 0,
          id_solicitante: user.id_usuario,
          nombre_solicitante: user.usuario,
          id_proveedor: idprovedor,
          nombre_proveedor: nombreProveedor,
          correo_proveedor: "jgal@mariaalmenara.pe",
          ruc_proveedor: ruc,
          id_proveedor_sap: codigoProveedorsap,
          id_contacto_proveedor: idcontacto,
          codigo_empleado_venta: selectPersonaContacto.codigo_empleado_venta,
          contacto_proveedor: selectPersonaContacto.nombre_empleado_venta,
          fecha_contable: moment(fechacontable).locale('es', MomentLocaleEs),
          fecha_entrega: moment(fechaentrega).locale('es', MomentLocaleEs),
          fecha_documento: moment(fechacontable).locale('es', MomentLocaleEs),
          fecha_registro: moment().locale('es', MomentLocaleEs),
          condic_pago: condiciondepago,
          destino: selectedDestino.nombre_direccion_destino,
          impuesto: Number(resultadoCalculo),
          total_antes_descuento: Number(sumaTotal),
          total_pago_vencido: Number(totalCalculado),
          observaciones: observaciones,
          tipo: "Servicio",
          motivo_solicitud: motivotraslado,
          moneda: tipocambio,
          tipo_cambio: 1,
          comentario:comment,
          // tipo_documento:tipoDocumento,
          // serie_documento:serieDocumento,
          // correlativo_documento:correlativoDocumento,
          oc_detalles:records.map(datos => datos &&{
            id_oc_detalle: 0,
            id_oc_cabecera: 0,
            fecha_entrega: datos.fecha_entrega,
            descripcion: datos.descripcion,
            numero_cuenta_mayor: datos.codigo_cuenta_contable,
            nombre_cuenta_mayor: datos.nombre_cuenta_contable,
            total_servicio: datos.incluyeIgv ? (datos.Valor_unitario*datos.incluyeIgv+datos.Valor_unitario).toFixed(2) : (datos.Valor_unitario).toFixed(2),
            codigo_cuenta_contable: datos.codigo_cuenta_contable,
            codigo_articulo:null,
            codigo_unidad_medida_articulo: null,
            unidad_medida_articulo: null,
            cantidad_pedida: null,
            precio_unitario: null,
            porcentaje_descuento: 0,
            total_articulo: null,
            codigo_ceco: datos.codigo_ceco,
            codigo_departamente: datos.codigo_departamente,
            codigo_seccion: datos.codigo_seccion,
            codigo_almacen_sap: null,
            created_at: moment().locale('es', MomentLocaleEs),
            updated_at: moment().locale('es', MomentLocaleEs),
            include_igv:datos.incluyeIgv===0.18 ? 'IGV' :datos.incluyeIgv===0.105 ?  'IGV_HR' :'EXONERADO',
            statusline:"0",
            AbsEntryProyecto:datos.AbsEntryProyecto? datos.AbsEntryProyecto:0,
            NombreProyecto:datos.NombreProyecto?? '',
            DocNumProyecto:String(datos.DocNumProyecto)?? '',
            FiProject:datos.fiProject?? '',
            StageIdEtapa:datos.StageIdEtapa?datos.StageIdEtapa: 0,
            NombreEtapa:datos.NombreEtapa ?? '',
            EnvioEtapa: datos.AbsEntryProyecto ? 'Si' : 'No'
          })
         }
         setRegistrarbtn(true);
    
        OrdenesService.insertarSolPe(datosOrden,setCargando,setSnackbar,user.token).then((res) => { 
         setRecords([]);
          setSelectProveedor(null);
          setRuc('');
          setSelectPersonaContacto(null);
          setCondicionDepago('')
          setMotivotraslado('');
          setObservaciones('');
           setSelectedDestino(null);
           setComment('');
          });
        // console.log(datosOrden)
      }
    })
  };

  //Nuevo
  const handleComentarioChange = e => {
    const { name, value } = e.target;
    setComment(value)
  }
  const handleObservaciones = e => {
    const { name, value } = e.target;
    setObservaciones(value)
  }
  const handleMotivoTraslado = e => {
    const { name, value } = e.target;
    setMotivotraslado(value)
  }
  const handleContable = (newValue) => {
    setFechacontable(newValue);
  }
  const handleEntrega = (newValue) => {
    setFechaentrega(newValue);
  }
  const handleRegistro = (newValue) => {
    setFecharegistro(newValue);
  }
  const handleSerieDocumento = e => {
    const { name, value } = e.target;
    setSerieDocumento(value)
  }
  const handleCorrelativoDocumento = e => {
    const { name, value } = e.target;
    setCorrelativoDocumento(value)
  }
  const handleChangeTipodeCambio = (event) => {
    setTipocambio(event.target.value);
  };
  const handleAutocompleteChange = (event, value) => {
    setSelectProveedor(value);
    setRuc(value.numero_documento);
    setIdprovedor(value.id_usuario);
    setNombreProvedor(value.razon_social);
    setCodigoProveedorsap(value.id_proveedor_sap);
    setCondicionDepago(value.nombre_condicion_credito);
    setCorreo( value.correo_recepcion!=='' ? value.correo_recepcion : value.correo_logistica !='' ?  value.correo_logistica : value.correo_comercial ? value.correo_comercial  : 'NO HAY CORREO EN SAP');
  };
  const filterOptions = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option.razon_social.toLowerCase().includes(inputValue.toLowerCase()) ||
        option.numero_documento.includes(inputValue)
    );
  };
  const handleAutocompletePersonaContacto = (event, value) => {
    setSelectPersonaContacto(value);
    setIdcontacto(value.codigo_empleado_venta);
  };
  const filterOptionsPersonaContacto = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option.nombre_empleado_venta.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const handleSelectConditionPago = (event, value) => {
    setSelectedConditionPago(value);
  };
  const filterOptionsDestino = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option.nombre_direccion_destino.toLowerCase().includes(inputValue.toLowerCase())
    );
  };
  const handleAutocompleteDestino = (event, value) => {
    setSelectedDestino(value);
  };
  
  const sumaTotal = records.reduce(
    (acumulado, datos) => acumulado + datos.Valor_unitario, 
    0
  );
  let igvTotal = 0;
  records.forEach(row => {
    if (row.incluyeIgv) {
      igvTotal += row.Valor_unitario * row.incluyeIgv; 
    }
  });
  
  const totalConIgv = sumaTotal + igvTotal;
  
  const totalCalculado = typeof totalConIgv === 'number'
    ? totalConIgv.toFixed(2)
    : 0;
    const resultadoCalculo = igvTotal.toFixed(2); 





  return (
    <Grid width={'100%'} m="auto">
      <Grid container justifyContent="flex-start" alignItems="center" spacing={2} sx={{ py: 1 }}>
        <Grid container item xs={12} sm={12} >
          <Grid item sm={6} >
            <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black"><b>CREAR SOLICITUD DE ORDEN DE SERVICIO</b></CMLabel>
          </Grid>
        </Grid>
        <Grid container item xs={12} sm={12} alignItems="center">
          <Grid item sm={12}>
            <Grid item xs={12} sm={12}>
              <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black"><b>Datos del proveedor</b></CMLabel>
            </Grid>
            <Grid container item xs={12} sm={12} alignItems="center">
              <Grid xs={12} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Proveedor</CMLabel>
              </Grid>
              <Grid xs={12} sm={2}>
                <Autocomplete
                  value={selectProveedor}
                  onChange={handleAutocompleteChange}
                  options={proveedor}
                  getOptionLabel={(option) => option.razon_social}
                  filterOptions={filterOptions}
                  renderInput={(params) => <TextField {...params} label="Buscar" />}
                />
              </Grid>
              <Grid xs={12} sm={0.5}>
              </Grid>
              <Grid xs={12} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">RUC</CMLabel>
              </Grid>
              <Grid xs={12} sm={2}>
                <CMTextField
                  name="ruc"
                  label='ruc'
                  value={ruc}
                  disabled
                  fullWidth
                />
              </Grid>
              <Grid xs={12} sm={0.5}>
              </Grid>
              <Grid xs={12} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Persona Contacto</CMLabel>
              </Grid>
              <Grid xs={12} sm={2}>
                <Autocomplete
                  value={selectPersonaContacto}
                  onChange={handleAutocompletePersonaContacto}
                  options={contacto}
                  getOptionLabel={(option) => option.nombre_empleado_venta}
                  filterOptions={filterOptionsPersonaContacto}
                  renderInput={(params) => <TextField {...params} label="Buscar persona contacto" />}
                />
              </Grid>
            </Grid>
            <Grid container item xs={12} sm={12} sx={{paddingTop:2}} alignItems="center">
            <Grid item sx={12} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Condición de pago</CMLabel>
            </Grid>
            <Grid item sx={12} sm={2}>
              <CMTextField
                  name="Condición de pago"
                  label='Condición de pago'
                  value={condiciondepago}
                  disabled
                  fullWidth
                />
            </Grid>
            <Grid xs={12} sm={0.5}>
              </Grid> 
            <Grid item sx={12} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Correo</CMLabel>
            </Grid>
            <Grid item sx={12} sm={2}>
              <CMTextField
                  name="Correo"
                  label='Correo'
                  value={correo}
                  disabled
                  fullWidth
                />
            </Grid>
            </Grid>
          </Grid>
          <Grid item sm={12}>
            <Grid item sm={12}>
              <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black"><b>Datos de la orden</b></CMLabel>
            </Grid>
            <Grid container item sm={12} alignItems="center">
              <Grid item sx={12} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Fecha contable</CMLabel>
              </Grid>
              <Grid item sx={12} sm={2}>
                <CMDatePicker
                  label="Fecha contable"
                  value={fechacontable}
                  inputFormat="DD/MM/YYYY"
                  onChange={handleContable}
                  maxDate={fechahoy}
                  minDate={moment(fechahoy).subtract(2, 'days')}
                  />
              </Grid>
              <Grid item sx={12} sm={0.5}>
                
              </Grid>
              <Grid item sx={12} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Fecha entrega</CMLabel>
              </Grid>
              <Grid item sx={12} sm={2}>
                <CMDatePicker
                  label="Fecha entrega"
                  value={fechaentrega}
                  inputFormat="DD/MM/YYYY"
                  onChange={handleEntrega}
                  minDate={moment(fechahoy).subtract(2, 'days')}
                  maxDate={fechahoy}

                />
              </Grid>
              <Grid item sx={12} sm={0.5}>

              </Grid>
              <Grid item sx={12} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Tipo de compra</CMLabel>
            </Grid>
            <Grid item sx={12} sm={2}>
              <CMTextField
                name="Tipo de compra"
                label='Tipo de compra'
                value="Compra Local"
                disabled
                fullWidth
              />
            </Grid>
            
            </Grid>
          </Grid>
          <Grid container item sx={{ paddingTop: 3, paddingBottom: 3 }} alignItems="center">
            <Grid item sx={12} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Tipo de moneda</CMLabel>
            </Grid>
            <Grid item sx={12} sm={2}>
              <Select
                labelId="currency-label"
                id="currency"
                value={tipocambio}
                onChange={handleChangeTipodeCambio}
                fullWidth
              >
                <MenuItem value="S/">S/ (Moneda Local)</MenuItem>
                <MenuItem value="US$">US$ (Moneda Extranjera)</MenuItem>
              </Select>
            </Grid>
            <Grid item sx={12} sm={0.5}>

            </Grid>
            <Grid item sx={4} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Motivo</CMLabel>
            </Grid>
            <Grid item sx={0.2}>
              <Tooltip title="Motivo control del sistema">
                <InfoIcon sx={{ color: 'primary.main'}}/>
              </Tooltip>
            </Grid>
            <Grid item sx={8} sm={1.8}>
                <CMTextField
                      name="Motivo"
                      label='Motivo'
                      value={motivotraslado}
                      onChange={handleMotivoTraslado}
                      fullWidth
                      inputProps={{
                        maxLength: 300
                      }}
                    />
            </Grid>
            <Grid item sx={12} sm={0.5}>

            </Grid>

            <Grid item sx={12} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Resumen</CMLabel>
            </Grid>
            <Grid item sx={12} sm={0.2}>
              <Tooltip title="Resumen de la orden SAP, en formato Resumen-Tienda">
                <InfoIcon sx={{ color: 'primary.main'}}/>
              </Tooltip>
            </Grid>
            <Grid item sx={12} sm={1.8}>
              <CMTextField
                name="Resumen"
                label='Resumen'
                value={observaciones}
                onChange={handleObservaciones}
                fullWidth
                inputProps={{
                  maxLength: 500
                }}
              />
            </Grid>
          </Grid>
          <Grid container item sx={{ paddingTop: 0, paddingBottom: 3 }} alignItems="center">
            <Grid item sx={12} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='14px' color="black">Destino</CMLabel>
            </Grid>
            <Grid item sx={12} sm={2}>
               <Autocomplete
                  value={selectedDestino}
                  onChange={handleAutocompleteDestino}
                  options={destino}
                  getOptionLabel={(option) => option.nombre_direccion_destino}
                  filterOptions={filterOptionsDestino}
                  renderInput={(params) => <TextField {...params} label="Buscar destino" />}
                />
            </Grid>
            <Grid item sx={12} sm={0.5}>
            </Grid>
            
          </Grid>
          {/* <Grid container item sx={{ paddingTop: 0, paddingBottom: 3 }} alignItems="center">
            <Grid item sx={12} sm={1.5}>
              <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black">Tipo Documento</CMLabel>
            </Grid>
            <Grid item sx={12} sm={2}>
                <CMTextField
                      name="Tipo del Documento"
                      label='Tipo del Documento'
                      value={tipoDocumento}
                      disabled
                      fullWidth
                    />
            </Grid>
              <Grid item sx={12} sm={0.5}>

              </Grid>
              <Grid item sx={4} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black">Serie Documento</CMLabel>
              </Grid>
              <Grid item sx={8} sm={2}>
                  <CMTextField
                        name="Serie del Documento"
                        label='Serie del Documento'
                        value={serieDocumento}
                        onChange={handleSerieDocumento}
                        fullWidth
                        inputProps={{
                          minLength: 4,
                          maxLength: 4
                        }}
                      />
              </Grid>
              <Grid item sx={12} sm={0.5}>

              </Grid>
              <Grid item sx={4} sm={1.5}>
                <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black">Correlativo Documento</CMLabel>
              </Grid>
              <Grid item sx={8} sm={2}>
                  <CMTextField
                        name="Correlativo del Documento"
                        label='Correlativo del Documento'
                        value={correlativoDocumento}
                        onChange={handleCorrelativoDocumento}
                        fullWidth
                        inputProps={{
                          minLength: 8,
                          maxLength: 8
                        }}
                      />
              </Grid>
          </Grid> */}
          <Grid container item sx={{ paddingTop: 0, paddingBottom: 3 }} alignItems="center">
            <Grid item sm={12}>
              <CMLabel sx={{ margin: 2 }} fontSize='20px' color="black"><b>Datos del Servicio</b></CMLabel>
            </Grid>
            <Grid container sm={12} alignItems="center">
                <Grid item sx={12} sm={2} >
                    <CMButton
                    label="Insertar Servicio"
                    variant="contained"
                    onClick={(e) => agregarServicio()}
                  />
                </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container item xs={12} sm={12}>
          <Grid style={{ height: 400, width: '100%', overflowX: 'auto' }} sx={{ py: 1 }}>
            <DataGrid
              rows={records ? records : []}
              columns={columns}
              sx={{
                height: "100%",
                 fontSize: 12,
                "& .MuiDataGrid-window": {
                  overflowX: 'scroll',
                  "&::-webkit-scrollbar": {
                    width: "0.4em",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#888",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#555",
                  },
                },
              }}
              pagination
              rowHeight={50}
              processRowUpdate={processRowUpdate}
              onProcessRowUpdateError={handleProcessRowUpdateError}
              experimentalFeatures={{ newEditingApi: true }}
              loading={cargando}
            />
            {!!snackbar && (
              <Snackbar
                open
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                onClose={handleCloseSnackbar}
                autoHideDuration={6000}
              >
                <Alert {...snackbar} onClose={handleCloseSnackbar} />
              </Snackbar>
            )}
          </Grid>
          <Grid item xs={12} sm={12} container>
            <Grid item xs={12} sm={6} container alignItems="center">
              <Grid item xs={6} sm={3}>
                {/* <CMLabel fontSize='16px' color='black'>Comentario: </CMLabel> */}
              </Grid>
              <Grid item xs={6} sm={6}>
                {/* <CMTextField
                  name="comment"
                  label='Comentario'
                  value={comment}
                  onChange={handleComentarioChange}
                  fullWidth
                /> */}
              </Grid>
            </Grid>
            <Grid item container>
                <Grid item container xs={12} sm={10}>

                </Grid>
                <Grid item container xs={12} sm={2} justifyContent="flex-end">
                  <Grid item xs={6} sm={6}>
                    <CMLabel sx={{ margin: 2 }} fontSize='16px' color="black">Subtotal</CMLabel>
                  </Grid>
                  <Grid item xs={6} sm={6}>
                  
                    <CMLabel sx={{ margin: 2 }} fontSize='16px' color="black">
                    {tipocambio==='S/' ? tipocambio : '$'}{sumaTotal} 
                    </CMLabel>

                  </Grid>
                </Grid>
                <Grid item container xs={12} sm={10}>

                </Grid>
                <Grid item container xs={12} sm={2} justifyContent="flex-end">
                  <Grid item xs={6} sm={6}>
                    <CMLabel sx={{ margin: 2 }} fontSize='16px' color="black">IGV</CMLabel>
                  </Grid>
                  <Grid item xs={6} sm={6}>
                  
                    <CMLabel sx={{ margin: 2 }} fontSize='16px' color="black">
                    {tipocambio==='S/' ? tipocambio : '$'}{ resultadoCalculo }
                    </CMLabel>

                  </Grid>
                </Grid>
                <Grid item container xs={12} sm={10}>

                </Grid>
                <Grid item container xs={12} sm={2} justifyContent="flex-end">
                  <Grid item xs={6} sm={6}>
                    <CMLabel sx={{ margin: 2 }} fontSize='16px' color="black">Total</CMLabel>
                  </Grid>
                  <Grid item xs={6} sm={6}>
                  
                    <CMLabel sx={{ margin: 2 }} fontSize='16px' color="black">
                    {tipocambio==='S/' ? tipocambio : '$'}{totalCalculado ? totalCalculado : 0}
                    </CMLabel>

                  </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} container justifyContent="flex-end">
              <CMButton
                label="Registrar"
                variant="contained"
                sx={{ marginTop: '10px' }}
                onClick={hanbleRegistrar}
                disabled={registrarbtn}
              />
            </Grid>

          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CrearOrdenesServicio